import watch from 'redux-watch';
import isNumber from 'lodash/isNumber'
import get from 'lodash/get';

class GridListItemCheckboxController {
    constructor($ngRedux, $scope) {
        this.$ngRedux = $ngRedux;
        this.$scope = $scope;
        this.itemsSelect = [];
        this.itemsDisabled = [];
    }

    $onInit() {
        if (typeof this.disabled === 'undefined')
            this.disabled = false;

        this.unsubscribeModule = this.$ngRedux.connect(this.mapModule, {})(this);
        this.unsubscribe = this.$ngRedux.connect(this.mapState.bind(this), {})(this);

        const watchSelected = watch(this.$ngRedux.getState, this.getStateContainer('itemsSelect'));
        this.unsubscribeWatchSelected = this.$ngRedux.subscribe(watchSelected(this.init.bind(this)));

        const watchDisabled = watch(this.$ngRedux.getState, this.getStateContainer('itemsDisabled'));
        this.unsubscribeWatchDisabled = this.$ngRedux.subscribe(watchDisabled(this.updateDisabled.bind(this)));

        this.init(this.itemsSelect);
        this.updateDisabled(this.itemsDisabled);
    }


    init(items) {
        this.checkboxValue = items?.includes(this.data) ? 1 : 0
    }

    updateDisabled(items) {
        this.disabled = !!items?.includes(this.data);
    }

    onSelect() {
        this.$scope.$emit('grid-checkbox-change', this.data, this.checkboxValue, this.statePath);
        this.$ngRedux.dispatch({
            type: this.checkboxValue ? 'GRID_SELECT' : 'GRID_DESELECT',
            id: this.identifier,
            path: this.statePath,
            data: isNumber(this.data) ? parseInt(this.data) : this.data
        });
    }

    $onDestroy() {
        this.unsubscribe();
        this.unsubscribeModule();

        if(this.unsubscribeWatchSelected)
            this.unsubscribeWatchSelected();

        if(this.unsubscribeWatchDisabled)
            this.unsubscribeWatchDisabled();
    }

    mapModule(state) {
        return {
            module: state.navigation.module
        }
    }

    getStateContainer(endPath) {
        if(this.statePath)
            endPath = `${this.statePath}.${endPath}`;
        return [this.module, this.identifier, endPath].join('.');
    }

    mapState(state) {
        return {
            itemsSelect: get(state, this.getStateContainer('itemsSelect')),
            itemsDisabled: get(state, this.getStateContainer('itemsDisabled'))
        }
    }
}

GridListItemCheckboxController.$inject = ['$ngRedux', '$scope'];

export const gridListItemCheckbox = {
    bindings: {
        module: '@',
        identifier: '@',
        statePath: '@',
        label: '@',
        disabled: '@',
        data: '@'
    },
    controller: GridListItemCheckboxController,
    template: `
        <md-input-container class="md-block checkbox">
            <md-checkbox ng-model="$ctrl.checkboxValue"
                         ng-true-value="1"
                         ng-false-value="0"
                         ng-change="$ctrl.onSelect()"
                         ng-disabled="$ctrl.disabled"
                         aria-label="$ctrl.label">
                <span>{{$ctrl.label}}</span>
            </md-checkbox>
        </md-input-container>
    `
};
